<template>
  <div class="footer">
    <div class="footer-content">
      <!-- 联系我们 -->
      <div class="footer-section">
        <h3 class="section-title">联系我们</h3>
        <div class="contact-info">
          <div class="office">
            <div class="contact-item">
              <span>{{ siteMap.company_name || '武汉恒毅新生物科技有限公司' }}</span>
            </div>
            <div class="contact-item">
              <span>{{ siteMap.company_address || '武汉市东湖新技术开发区光谷生物城C1栋212' }}</span>
            </div>
            <div class="contact-item">
              <span>{{ siteMap.phone || '+86 18627010615' }}</span>
            </div>
            <div class="contact-item">
              <span>{{ siteMap.email || '115956559@qq.com' }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="footer-section">
        <h3 class="section-title">产品与服务</h3>
        <ul class="link-list">
          <li>核心载体制备</li>
          <li>细胞模型构建</li>
          <li>CRISPR文库筛选</li>
          <li>基因编辑有效性检测</li>
          <li>基因编辑安全性评估</li>
        </ul>
      </div> -->

      <!-- <div class="footer-section">
        <h3 class="section-title">用户服务</h3>
        <ul class="link-list">
          <li>产品资源</li>
          <li>客服中心</li>
          <li>在线支持</li>
          <li>技术服务</li>
        </ul>
      </div> -->

      <!-- 关注我们 -->
      <div class="footer-section">
        <h3 class="section-title">关注我们</h3>
        <div class="qr-codes">
          <div class="qr-item">
            <img v-lazy="qrImageUrl" alt="恒毅新生物二维码" class="qr-image" />
            <span>恒毅新生物</span>
          </div>
        </div>
      </div>
    </div>
    <div class="copyright">
      <span>
        <a
          :href="beianLink"
          target="_blank"
          rel="noopener noreferrer"
          class="beian-link">{{ siteMap.copyright || '©版权所有:武汉恒毅新生物科技有限公司' }}</a>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      siteMap: {},
      loadingSite: false,
      beianLink: 'https://beian.miit.gov.cn'
    }
  },
  computed: {
    qrImageUrl() {
      const url = this.siteMap.qrcode
      if (!url) {
        return require('../../assets/img/qrcode.jpg')
      }
      return this.resolveImageUrl(url)
    }
  },
  mounted() {
    this.loadAllSiteItems()
  },
  methods: {
    async loadAllSiteItems() {
      if (this.loadingSite) return
      this.loadingSite = true
      try {
        const res = await this.$http.get('/api/site/all-site-items')
        const list = (res && res.data && res.data.data) || []
        if (Array.isArray(list)) {
          const map = {}
          list.forEach(item => {
            if (item && item.key) {
              map[item.key] = item.value
            }
          })
          this.siteMap = map
        }
      } catch (e) {
        // 静默失败，沿用默认内容
        console.error('加载网站配置失败', e)
      } finally {
        this.loadingSite = false
      }
    },
    resolveImageUrl(url) {
      if (!url) return require('../../assets/img/qrcode.jpg')
      const str = String(url)
      const lower = str.toLowerCase()
      if (lower.startsWith('http://') || lower.startsWith('https://') || lower.startsWith('data:') || lower.startsWith('//')) {
        return str
      }
      const base = this.imgserver || ''
      if (str.startsWith('/')) return `${base}${str}`
      return `${base}/${str}`
    }
  }
};
</script>

<style lang="scss" scoped>
.footer {
  width: 100%;
  background-color: #5e7c85;
  color: #ffffff;
  
  &-content {
    max-width: 90%;
    margin: 0 auto;
    padding: 1rem 0 0;
    display: flex;
    justify-content: space-around;
    
  }
  
  .footer-section {
    .section-title {
      font-size: 1.25rem;
      font-weight: 600;
      color: #ffffff;
      margin-bottom: 0.75rem;
    }
    
    .contact-info {
      .office {
        
        h4 {
          font-size: 1rem;
          font-weight: 500;
          color: #ffffff;
          margin-bottom: 0.75rem;
        }
        
        .contact-item {
          display: flex;
          align-items: center;
          margin-bottom: 0.5rem;
          font-size: 1rem;
          
          i {
            width: 16px;
            height: 16px;
            margin-right: 8px;
            display: inline-block;
          }
        }
      }
    }
    
    .link-list {
      list-style: none;
      padding: 0;
      margin: 0;
      
      li {
        font-size: 1rem;
        margin-bottom: 0.25rem;
        cursor: pointer;
        transition: color 0.3s ease;
        
        &:hover {
          color: #ffffff;
        }
      }
    }
    
    .qr-codes {
      display: flex;
      gap: 1rem;
      
      .qr-item {
        text-align: center;
        
        .qr-image {
          width: 80px;
          height: 80px;
          border-radius: 8px;
          object-fit: cover;
          display: block;
          margin: 0 auto;
        }
        
        span {
          font-size: 12px;
          display: block;
          margin-top: 8px;
        }
      }
    }
    
    .consult-btn {
      background-color: #666;
      color: #ffffff;
      border: none;
      border-radius: 6px;
      padding: 10px 20px;
      font-size: 13px;
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 8px;
      transition: background-color 0.3s ease;
      
      &:hover {
        background-color: #777;
      }
      
      .icon-plane::before {
        content: "✈️";
      }
    }
  }
  
  .copyright {
    // background-color: #0f0f0f;
    padding: 0 0 0.5rem;
    text-align: center;
    // border-top: 1px solid #333;
    
    span {
      font-size: 12px;
      color: #fff;
    }

    .beian-link {
      color: #fff;
      text-decoration: none;
    }

    .beian-link:hover {
      text-decoration: underline;
    }
  }
}

@media (max-width: 768px) {
  .footer {
    &-content {
      grid-template-columns: 1fr;
      gap: 30px;
      padding: 40px 20px 30px;
    }
    
    .qr-codes {
      justify-content: center;
    }
  }
}
</style>
